import { useMutation } from '@tanstack/react-query';
import { ory, clearSessionCache } from 'src/auth/ory';
import { clearSteeringStorage } from 'src/UI/app-container/steering/useSteering';

export function useLogout({ onError }: { onError?: (error: unknown) => void } = {}) {
  return useMutation({
    mutationFn: async () => {
      clearSessionCache();
      sessionStorage.clear();
      clearSteeringStorage();
      const { data: flow } = await ory.createBrowserLogoutFlow();
      await ory.updateLogoutFlow({ token: flow.logout_token });
    },
    onSuccess: () => {
      window.location.replace('/login');
    },
    onError,
  });
}
